import { PureComponent, forwardRef } from 'react';
import * as ReactDOM from 'react-dom';
import { noop } from 'lodash';
import { NO_HEIGHT } from 'styles/commonClasses';

// COMPONENTS
import OutsideClickAlerter from 'components/OutsideClickAlerter';

// STYLES
import { TooltipWrapper } from './Tooltip.styles';

// HOCS
import withParentPosition from 'hocs/ParentPosition';

interface TooltipPropsType {
  className?: string;
  forwardedRef?: any;
  maxHeight?: number;
  width?: number;
  offset?: number;
  onOutsideClick?: (event: MouseEvent) => void;
  WrapperComponent?: any;
  rootElement?: HTMLElement;
  isShown?: boolean;
  getParentPosition?: () => any;
}

export class Tooltip extends PureComponent<TooltipPropsType> {
  static defaultProps = {
    className: '',
    forwardedRef: undefined,
    maxHeight: 300,
    width: undefined,
    offset: 0,
    onOutsideClick: noop,
    WrapperComponent: TooltipWrapper,
  };

  componentDidMount() {
    if (this.props.rootElement) {
      const { el } = this;
      el.className = 'dropdowmenu-portal';
      this.props.rootElement.appendChild(el);
    }
  }

  componentWillUnmount() {
    this.props.rootElement?.removeChild(this.el);
  }

  el = document.createElement('div');

  render() {
    const { forwardedRef, maxHeight, width, WrapperComponent, offset } = this.props;
    let { className } = this.props;

    // We use height based hiding to avoid re-renders on long lists and to
    // avoid breaking height calcuations in the Dropdown
    className += this.props.isShown ? '' : ` ${NO_HEIGHT}`;
    const parentPosition = this.props.isShown ? this.props.getParentPosition() : {};

    return ReactDOM.createPortal(
      <OutsideClickAlerter onOutsideClick={this.props.onOutsideClick}>
        <WrapperComponent
          ref={forwardedRef}
          className={className}
          parentPosition={parentPosition}
          maxHeight={maxHeight}
          offset={offset}
          width={width}
        >
          {this.props.children}
        </WrapperComponent>
      </OutsideClickAlerter>,
      this.el
    );
  }
}

export default withParentPosition(forwardRef((props, ref) => <Tooltip forwardedRef={ref} {...props} />));
